import axios from 'axios';
import { serverURL } from '../../constants';
import { Button } from 'flowbite-react';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { DefaultEditor } from 'react-simple-wysiwyg';

const TermsEdit = () => {

    const [terms, setTerms] = useState(sessionStorage.getItem('terms') || '');

    async function saveTerms() {
        const postURL = serverURL + '/api/saveadmin';
        const response = await axios.post(postURL, { data: terms, type: 'terms' });
        if (response.data.success) {
            sessionStorage.setItem('terms', terms);
            toast.success(response.data.message);
        }
    }

    return (
        <div>
            <div className='flex flex-row items-center'>
                <h1 className='text-black font-black text-3xl p-4'>Terms</h1>
                <Button onClick={saveTerms} className='text-center dark:bg-white dark:text-black bg-black text-white font-bold rounded-none max-w-md enabled:hover:bg-black enabled:focus:bg-black enabled:focus:ring-transparent dark:enabled:hover:bg-white dark:enabled:focus:bg-white dark:enabled:focus:ring-transparent m-4'>Submit</Button>
            </div>
            <div className="m-4">
                <DefaultEditor value={terms} onChange={e => setTerms(e.target.value)} />
            </div>
        </div>
    );
};

export default TermsEdit;
